import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserOffers, getUserOffersId } from "config/api/offers.api";
import SelectedOfferContext from "config/selectedOfferContext";
import OrderOptions from "views/Offers/OrderOptions";
import useLocalStorage from "components/hooks/useLocalStorage";
import Section from "components/common/Section";
import Button from "components/common/Button";
import LoadingOffers from "./LoadingOffers";
import styles from "./Offers.module.scss";
import OfferDetail from "./OfferDetail";

const Offers: React.FC = () => {
  const { selectedOffer, setOfferId } = useContext(SelectedOfferContext);
  const [offers, setOffers] = useState([] as any[]);
  const userData = useLocalStorage("userData", {}).storedValue;
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setloading(true);
    const userId = Number(userData["id"]);
    const locationId = Number(userData["locationData"][0]["id"]);
    getUserOffers(userId, locationId).then((offers) => {
      setloading(false);
      setOffers(offers);
    });
    getUserOffersId(userId, locationId).then((offerId) => {
      setOfferId(offerId);
    });
  }, [userData, setOfferId]);

  if (loading) {
    return <LoadingOffers />;
  }

  const noOfferSelected = (
    <div className={styles["no-option-wrapper"]}>
      <p className={styles["no-option-message"]}>
        ¡Parece que aún no has seleccionado una opción!
      </p>
      <img
        className={styles.image}
        src="/empty-cart-no-face.jpg"
        alt="no offer selected"
      />
    </div>
  );

  const actions = (
    <div className={styles.actions}>
      <Button color="primary" action={() => navigate(`../carrito/productos`)}>
        Regresar
      </Button>
      <Button
        color="primary-filled"
        disable={selectedOffer.total < 4000}
        action={() => navigate(`../carrito/pago`)}
      >
        Continuar
      </Button>
    </div>
  );
  return (
    <div>
      <Section
        title="Elige el tipo de envío de tu preferencia"
        titleSize="small"
        widthSize="full"
      >
        <div className={styles.body}>
          <div className={styles.options}>
            <p>1.- Seleccionar opción de envío.</p>
            <p className={styles["options-subtitle"]}>
              Ve las opciones para elegir la mejor para ti
            </p>
            <OrderOptions options={offers} />
          </div>
          <div className={`${styles.options} ${styles["option-detail"]}`}>
            <p>2.- Revisar la información de la opción seleccionada.</p>
            {!selectedOffer.type ? noOfferSelected : <OfferDetail />}
          </div>
        </div>
      </Section>
      {actions}
    </div>
  );
};

export default Offers;
